import { useGlobalState } from '@/global-state/useGlobalState'
import { mutationWithFeedback } from '@/utils/toast'
import { trpc } from '@/utils/trpc'

export const useCreateView = () => {
  const handleViewChange = useGlobalState((state) => state.handleViewChange)
  const utils = trpc.useUtils()
  const { mutateAsync: createView, isPending } =
    trpc.view.createView.useMutation()
  const mutateAsync = async ({
    name,
    networkId,
  }: {
    name?: string
    networkId: string
  }) => {
    const mutation = async () => {
      const newViewId = await createView({
        viewName: name,
        networkId: networkId,
      })
      await utils.view.getViews.invalidate()
      handleViewChange()
      return newViewId
    }
    return await mutationWithFeedback({
      mutation: mutation(),
      successText: 'Created view!',
      errorText: 'Failed to create new view!',
    })
  }
  return { mutateAsync, isPending }
}
